/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';

interface CioModalConfirmSaveDelayActionArgs {
  campaign: CampaignModel;
  description?: string;
  subjectCount: number;
  typeName: string;
  onClose: () => void;
  onConfirm: () => void;
}
export default class CioModalConfirmSaveDelayAction extends Component<CioModalConfirmSaveDelayActionArgs> {
  get description() {
    return this.args.description ?? 'Saving your changes to';
  }

  get modalTitle() {
    let typeName = this.args.typeName.toLowerCase();
    let description = this.description.toLowerCase();

    return `Confirm ${description} this ${typeName}`;
  }
}
